export default __webpack_public_path__ + "static/media/connex.c7631e4f.png";